import React from 'react';

import LandbotService from 'services/Landbot.service';
import { Layout, Landbot } from 'components';

export default function LandbotClickPage() {
  return (
    <LandbotService>
      <Layout>
        <Landbot
          forceVisible
          mode="click"
          config={{
            configUrl:
              'https://chats.landbot.io/v3/H-728985-KI54TOCDS445FI2D/index.json',
          }}
        />
      </Layout>
    </LandbotService>
  );
}
